// extracted by mini-css-extract-plugin
export default {"view-history-button":"PrescriptionsGridContainer_view-history-button__XPDXJ"};